<template>
    <v-container fluid>
        <h1 class="text-center bot-blue">Chỉnh sửa thông tin ảnh</h1>
        <bot-spinner v-model="spinner">
            <v-file-input
                v-model="values.files"
                placeholder="Upload files"
                label="Upload files"
                accept="image/png, image/jpeg"
                show-size
                multiple
            ></v-file-input>
            <fieldset class="fieldset-table">
                <v-form
                    v-model="isValid"
                    ref="form"
                    @keyup.native.enter="submit"
                    @submit.prevent="submit"
                >
                </v-form>
                <legend>
                    <v-checkbox
                        v-model="values.resize"
                        label="resize"
                        color="success"
                    ></v-checkbox>
                </legend>
                <v-row>
                    <v-col>
                        <v-text-field
                            autofocus
                            v-model="values.XPSubject"
                            label="Tiêu đề bài viết"
                            :rules="[
                                (val) =>
                                    vld.text({
                                        field: 'tiêu đề bài viết',
                                        value: val,
                                    }),
                            ]"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <metadata-logo ref="mlogo" @onChange="onLogoChange" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="values.latitudeDegrees"
                            label="vĩ độ"
                            :rules="[
                                (val) =>
                                    vld.text({
                                        field: 'vĩ độ',
                                        value: val,
                                    }),
                            ]"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="values.longitudeDegrees"
                            label="kinh độ"
                            :rules="[
                                (val) =>
                                    vld.text({
                                        field: 'kinh độ',
                                        value: val,
                                    }),
                            ]"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-bind="columns">
                        <v-text-field
                            v-model="values.Copyright"
                            label="Tác quyền công ty"
                            :rules="[
                                (val) =>
                                    vld.text({
                                        field: 'tác quyền',
                                        value: val,
                                    }),
                            ]"
                        ></v-text-field>
                    </v-col>
                    <v-col v-bind="columns">
                        <v-text-field
                            v-model="values.XPComment"
                            label="Comments"
                            :rules="[
                                (val) =>
                                    vld.text({
                                        field: 'Comments',
                                        value: val,
                                    }),
                            ]"
                        ></v-text-field>
                    </v-col>
                    <v-col v-bind="columns">
                        <v-text-field
                            v-model="values.XPAuthor"
                            label="Tác giả sáng tác"
                            :rules="[
                                (val) =>
                                    vld.text({
                                        field: 'tác giả',
                                        value: val,
                                    }),
                            ]"
                        ></v-text-field>
                    </v-col>
                    <v-col v-bind="columns">
                        <v-combobox
                            v-model="values.XPKeywords"
                            chips
                            clearable
                            label="Từ khóa"
                            append-icon=""
                            multiple
                            solo
                        >
                            <template
                                v-slot:selection="{
                                    attrs,
                                    item: chip,
                                    select,
                                    selected: slt,
                                }"
                            >
                                <v-chip
                                    v-bind="attrs"
                                    :input-value="slt"
                                    close
                                    @click="select"
                                    @click:close="removeKeyword(chip)"
                                >
                                    {{ chip }}
                                </v-chip>
                            </template>
                        </v-combobox>
                    </v-col>
                </v-row>
            </fieldset>
            <div class="text-center">
                <v-btn class="ma-2" color="primary" @click="submit">
                    Xác nhận
                    <v-icon right> mdi-check </v-icon>
                </v-btn>
            </div>
        </bot-spinner>
    </v-container>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
import MetadataLogo from "./tool.file.metadata.logo.vue";
const cafe = {
    default: {
        key: "/temp",
        sp: {
            snb: "views/snackbar/show",
            authen: {
                loadConfig: "authen/loadConfig",
            },
            tool: {
                file: {
                    metadata: {
                        write: "tool/file/metadata/write",
                    },
                },
            },
        },
        values: {
            srcLogo:
                "/public/images/upload/profile/VIP000000015/logo-xdgk-01.jpg",
        },
        maxSize: 6 * 1024, //6MB
    },
    sms: {
        success: {
            write: "Ghi ảnh thành công!",
        },
    },
};
const df = cafe.default;

export default {
    name: "tool-file-metadata",

    components: {
        "bot-spinner": BotSpinner,
        "metadata-logo": MetadataLogo,
    },

    // this is state
    data() {
        return {
            vld: this.$options.filters.validate,
            hlog: this.$options.filters.hlog,
            cpo: this.$options.filters.cpo,
            hdownload: this.$options.filters.hdownload,
            fii: this.$options.filters.is.image,
            tufl: this.$options.filters.tufl,
            isValid: false,
            columns: {
                cols: "12",
                xs: "12",
                sm: "6",
                md: "6",
                lg: "6",
                xl: "4",
            },
            values: {
                files: null,
                resize: false,
                latitudeDegrees: null,
                longitudeDegrees: null,
                Rating: 4,
                Copyright: null,
                XPComment: null,
                XPAuthor: null,
                XPKeywords: [],
                XPSubject: "Hướng dẫn chọn size xe đạp cho bé từ 1-3 tuổi",
            },
            snackbar: {
                visible: false,
                text: "Hello snackbar!",
                color: "warning",
            },
            spinner: {
                visible: false,
                color: "red",
            },
        };
    },

    async asyncData({ store }) {
        const dp = store.dispatch;
        await dp(df.sp.authen.loadConfig);
    },

    mounted() {
        let main = this;
        let {
            latitudeDegrees,
            longitudeDegrees,
            Rating,
            Copyright,
            XPComment,
            XPAuthor,
            XPKeywords,
            XPSubject,
        } = main.values;
        main.values.latitudeDegrees =
            main.cftf.latitudeDegrees || latitudeDegrees;
        main.values.longitudeDegrees =
            main.cftf.longitudeDegrees || longitudeDegrees;
        main.values.Rating = main.cftf.Rating || Rating;
        main.values.Copyright = main.cftf.Copyright || Copyright;
        main.values.XPComment = main.cftf.XPComment || XPComment;
        main.values.XPAuthor = main.cftf.XPAuthor || XPAuthor;
        main.values.XPKeywords = main.cftf.XPKeywords || XPKeywords;
        main.values.XPSubject = main.cftf.XPSubject || XPSubject;
    },

    computed: {
        cftf() {
            let main = this;
            let cf = main.$store.state.authen.config;
            let data = main.cpo(cf.ConfigToolFile || { logos: [] });

            return data;
        },
    },

    methods: {
        async submit() {
            /*********|form validate|*********/
            let main = this;
            const { form, mlogo } = main.$refs;
            if (!form || !mlogo) return;
            main.isValid = form.validate();
            let logo = mlogo.selected;
            if (!main.isValid || !logo) return;
            const {
                files,
                Rating,
                Copyright,
                resize,
                latitudeDegrees,
                longitudeDegrees,
                XPKeywords,
            } = main.values;
            if (!Array.isArray(files) || !files.length) return;

            /*********|config filter|*********/
            console.clear();
            main.spinner.visible = true;
            const dp = main.$store.dispatch;
            let XPComment = [];
            // let XPKeywords = [];
            for (let comment of main.values.XPComment.split(";")) {
                if (!comment || !comment.trim()) continue;
                let xpc = comment.trim().toLowerCase();
                if (!XPComment.includes(xpc)) XPComment.push(xpc);
            }
            // for (let keyword of main.values.XPKeywords.split(";")) {
            //     if (!keyword || !keyword.trim()) continue;
            //     let xpkw = keyword.trim().toLowerCase();
            //     if (!XPKeywords.includes(xpkw)) XPKeywords.push(xpkw);
            // }
            let payload = {
                key: df.key,
                logo,
                resize,
                latitudeDegrees,
                longitudeDegrees,
                files: [],
                Rating,
                Copyright,
                XPComment: XPComment.join(";"),
                XPKeywords: XPKeywords.join(";"),
                XPAuthor: main.tufl(main.values.XPAuthor),
                XPSubject: main.tufl(main.values.XPSubject),
            };
            for (let file of files) {
                let isImage = main.fii(file.type);
                const isLtMax = file.size / 1024 < df.maxSize;
                if (!isImage || !isLtMax) continue;
                payload.files.push(file);
            }
            main.hlog.start("submit", "start", payload);
            let res_write = await dp(df.sp.tool.file.metadata.write, payload);
            let text = res_write.error;
            if (text) return dp(df.sp.snb, { text, color: "error" });
            text = cafe.sms.success.write;
            dp(df.sp.snb, { text, color: "success" });
            let { fileName } = res_write.data;
            let href = fileName.substring(1, fileName.length);
            main.hdownload.file(href);
        },
        onLogoChange(logo) {
            if (!logo) return;
            let main = this;
            const {
                latitudeDegrees,
                longitudeDegrees,
                Rating,
                Copyright,
                XPComment,
                XPAuthor,
                XPKeywords,
            } = logo;
            let a = main.values;
            let b = {
                latitudeDegrees,
                longitudeDegrees,
                Rating,
                Copyright,
                XPComment,
                XPAuthor,
                XPKeywords,
            };
            main.values = Object.assign(a, b);
        },
        removeKeyword(child) {
            var main = this;
            let { XPKeywords } = main.values;
            if (!Array.isArray(XPKeywords)) return;
            XPKeywords = main.cpo(XPKeywords);
            XPKeywords.splice(XPKeywords.indexOf(child), 1);
            main.values.XPKeywords = XPKeywords;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// tool.file.metadata.vue